export enum OrderExpirationType {
  Day = 'DAY',
  Day24h = 'DAY_EXT',
  UntilCanceled = 'GTC',
}
